import { render, staticRenderFns } from "./OrderViewActions.vue?vue&type=template&id=28a9af16&scoped=true&"
import script from "./OrderViewActions.vue?vue&type=script&lang=js&"
export * from "./OrderViewActions.vue?vue&type=script&lang=js&"
import style0 from "./OrderViewActions.vue?vue&type=style&index=0&id=28a9af16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a9af16",
  null
  
)

export default component.exports